import { useTranslation } from 'react-i18next';
import type { PlayerTab } from '../../hooks/usePlayerTab';

const Tabs: { tab: PlayerTab; label: string }[] = [
  { tab: 'game', label: 'editor.tabGame' },
  { tab: 'scenes', label: 'editor.tabScenes' },
];

interface PlayerTabsProps {
  tab: PlayerTab;
  onChange: (tab: PlayerTab) => void;
}

/** The owner's strip above the game area that switches between playing the game and editing its scenes. */
export default function PlayerTabs({ tab, onChange }: PlayerTabsProps) {
  const { t } = useTranslation();

  return (
    <div role="tablist" style={{ display: 'flex', justifyContent: 'center', gap: 4, padding: '8px 28px', borderBottom: '1px solid var(--line)' }}>
      {Tabs.map((item) => (
        <button
          key={item.tab}
          type="button"
          role="tab"
          aria-selected={tab === item.tab}
          className={tab === item.tab ? 'btn primary sm' : 'btn sm'}
          onClick={() => onChange(item.tab)}
        >
          {t(item.label)}
        </button>
      ))}
    </div>
  );
}
